import React from 'react';
import styled from 'styled-components';
import defaultImg from './assets/default-nav-icon.svg';
import Arrow from './assets/arrowDropDown.svg';

type Props = {
  photo?: {
    id: string;
    path: string;
  };
  label?: string;
  sublabel?: string;
  isMobileView?: boolean;
};

const UserProfileDropDown = ({
  photo,
  label,
  sublabel,
  isMobileView,
}: Props) => {
  const handleChildImageError = event => {
    event.target.src = defaultImg;
    event.target.className = 'default';
  };

  return (
    <Wrapper>
      <ProfileDropDownWrapper>
        <div className="icon-label">
          <ImageWrapper>
            {photo?.path === null || photo?.path === undefined ? (
              <div className="default-wrapper">
                <img src={defaultImg} alt="preview" />
              </div>
            ) : (
              <div className="default-preview-wrapper">
                <img
                  src={photo?.path}
                  alt="menu-icon"
                  onError={handleChildImageError}
                />
              </div>
            )}
            <OnlneCircleWrap />
          </ImageWrapper>

          {!isMobileView && (
            <>
              <LabelWrapper>
                <LabelLarge title={label}>{label}</LabelLarge>
                <SubLabel title={sublabel}>{sublabel}</SubLabel>
              </LabelWrapper>

              {/* <img src={Arrow} alt="arrow-icon" className="arrow-style" /> */}
            </>
          )}
        </div>
      </ProfileDropDownWrapper>
    </Wrapper>
  );
};

export default UserProfileDropDown;

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  margin-right: 33px;
  margin-left: 18px;
`;

const ProfileDropDownWrapper = styled.div`
  .icon-label {
    display: flex;
    gap: 12px;
  }
`;

const LabelLarge = styled.label`
  font-size: 11px;
  font-weight: 700;
  color: ${p => p.theme.black};
  font-family: 'Open Sans';
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  @media (max-width: 768px) {
    font-size: 7.33px;
  }
  @media (min-width: 769px) and (max-width: 991px) {
    font-size: 7.57px;
  }
  @media (min-width: 992px) and (max-width: 1023px) {
    font-size: 7.81px;
  }
  @media (min-width: 1024px) and (max-width: 1279px) {
    font-size: 9.77px;
  }
  @media (min-width: 1280px) and (max-width: 1365px) {
    font-size: 10.43px;
  }
  @media (min-width: 1366px) and (max-width: 1439px) {
    font-size: 10.99px;
  }
  @media (min-width: 1440px) and (max-width: 1600px) {
    font-size: 12.22px;
  }
  @media (min-width: 1601px) and (max-width: 1799px) {
    font-size: 13.74px;
  }
`;

const SubLabel = styled.label`
  font-size: 12px;
  font-weight: 400;
  color: ${p => p.theme.navBarLabelColor};
  font-family: 'Open Sans';
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  @media (max-width: 768px) {
    font-size: 8px;
  }
  @media (min-width: 769px) and (max-width: 991px) {
    font-size: 8.26px;
  }
  @media (min-width: 992px) and (max-width: 1023px) {
    font-size: 8.53px;
  }
  @media (min-width: 1024px) and (max-width: 1279px) {
    font-size: 10.66px;
  }
  @media (min-width: 1280px) and (max-width: 1365px) {
    font-size: 11.38px;
  }
  @media (min-width: 1366px) and (max-width: 1439px) {
    font-size: 11.99px;
  }
  @media (min-width: 1440px) and (max-width: 1600px) {
    font-size: 13.33px;
  }
  @media (min-width: 1601px) and (max-width: 1799px) {
    font-size: 14.99px;
  }
`;

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ImageWrapper = styled.div`
  width: 28px;
  height: 28px;
  @media (max-width: 768px) {
    height: 40px;
    width: 40px;
  }

  position: relative;
  .default-preview-wrapper {
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${p => p.theme.navBarDefaultBgColor};
    width: 28px;
    min-width: 28px;
    height: 28px;
    object-fit: cover;
    background-size: contain;

    img {
      width: 100%;
      border-radius: 50px;
      height: 28px;
      max-height: 100%;
      &.default {
        width: 18px;
        height: 18px;
        min-height: 18px;
      }
    }
    @media (max-width: 768px) {
      width: 40px;
      min-width: 40px;
      height: 40px;
      img {
        height: 40px;
        max-height: 100%;
        &.default {
          width: 30px;
          height: 30px;
          min-height: 30px;
        }
      }
    }
  }
`;

const OnlneCircleWrap = styled.div`
  position: absolute;
  border-radius: 50%;
  background: ${p => p.theme.navBarOnlineColor};
  height: 8px;
  width: 8px;
  right: 0px;
  bottom: 0px;
  border: 0.94px solid ${p => p.theme.white};
`;
